import {IconButton} from '@mui/material';
import {ArrowBack} from '@mui/icons-material';
import {Link} from 'react-router-dom';

export default function GoHome() {
    return <IconButton to='/' component={Link}><ArrowBack/></IconButton>;
}